import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'dateFormat' })
export class DateFormatPipe implements PipeTransform {
    transform(date: string, format: string = 'DD-MM-YYYY'): string {
        if (date == null) return '';

		let d = moment(date, 'YYYY-MM-DD hh:mm:ss');

		return d.format(format);
    }
}


// WEBPACK FOOTER //
// ./src/app/exa/_pipe/date-format.pipe.ts